import moment from "moment";

import { userData } from "./functions";

import { professionalClassCouncilValue } from "./format";

import api from "../services/api";

export const showUserOnPrint = async ({ about = "Não identificado" }) => {
    try {
        let { user } = userData();

        let text = `${professionalClassCouncilValue({
            id: user.professional_class_council_id,
            name: user.name,
            profile: user.profile_name,
            cpf: user.cpf,
            office: user.office,
            value: user.professional_class_council_value,
        })} - ${moment().format("DD/MM/YYYY HH:mm:ss")}`;

        let body = {
            about,
            text
        }

        await api.post("/rest-home/show-user-on-print", body);
    } catch (error) {
        console.log(error);
    }
}